// extracted by mini-css-extract-plugin
export var equalColumn = "_hj-0";